// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

reportWebVitals();

// Service Worker 註冊（僅在生產環境）
// 符合 CRA 最佳實踐：開發環境不啟用 SW，避免快取干擾開發體驗
// 參考：https://create-react-app.dev/docs/making-a-progressive-web-app/
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => {
        console.log('✅ Service Worker registered');
      })
      .catch(error => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
} else if (process.env.NODE_ENV === 'development') {
  console.log('ℹ️ Service Worker disabled in development (CRA best practice)');
}